import { QueryClient, keepPreviousData } from '@tanstack/vue-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      placeholderData: keepPreviousData,
      retry: 1,
      // Admin/SaaS console doesn't want tab-focus thrash. Legacy never
      // refetched on focus either; mutation + WS push + bridge invalidate
      // are the freshness paths.
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
